//弱视问题
let ruoshiInfo = [
  {
    tit: "矫正视力 (戴镜视力)",
    type: "2",
    key: "Vision",
  },
  {
    tit: "单眼弱视还是双眼弱视",
    option: ["单眼弱视", "双眼弱视"],
    key: "type",
  },
  {
    tit: "双眼看东西可能存在色彩明暗偏差?",
    option: ["是", "否"],
    key: "isPiancha",
  },
  {
    tit: "阅读时偶尔有跳读、串行现象?",
    option: ["是", "否"],
    key: "yueDu",
  },
  {
    tit: "是否存在走路容易摔跤?",
    option: ["是", "否"],
    key: "shiChang",
  },
  {
    tit: "视知觉训练提高弱视眼视力并建立立体视，了解一下?",
    option: ["非常想了解", "一般"],
    key: "liaoJie",
  },
  {
    tit: "  视知觉训练课程，您每天能坚持的时长?",
    option: ["30分钟-40分钟", "60分钟左右"],
    key: "shichang",
  },
];
// 视疲劳信息
let shipilaoInfo = [
  {
    tit: "看书或阅读大段文字时感到眼睛模糊？",
    option: ["是", "否"],
    key: "yanJingMoHu",
  },
  {
    tit: "有时需要重复性阅读同一行",
    option: ["是", "否"],
    key: "chongFuYueDu",
  },
  {
    tit: "看东西远近转换时，需要等待一会眼睛才能看清？",
    option: ["是", "否"],

    key: "yuanJinZhuanHuan",
  },
  {
    tit: "用眼时间长了，眼睛感到干涩、酸胀和不适",
    option: ["是", "否"],

    key: "yanJingBuShi",
  },
  {
    tit: " 阅读时偶然还会头痛，有明显视疲劳症状",
    option: ["是", "否"],

    key: "shiPiLaoZhengZhuang",
  },
  {
    tit: "视知觉训练缓解视疲劳的机制独特，希望了解一下？",
    option: ["需要", "一般"],

    key: "huanJieJiZhi",
  },
  {
    tit: "视知觉训练课程，您每天能坚持的时长？",
    option: ["20-30分钟", "40分钟左右"],
    key: "shiChang",
  },
];
let laohuaInfo = [
  {
    tit: "看手机、看书时不自觉的把手机或书拿远",
    option: ["是", "否"],

    key: "naYuan",
  },
  {
    tit: "  用眼会感觉视力模糊、不舒服？",
    option: ["是", "否"],

    key: "yongYanMoHu",
  },
  {
    tit: "看手机时把字体调大，亮度调高？",
    option: ["是", "否"],

    key: "fangDa",
  },
  {
    tit: "看视知觉训练可以延缓眼睛的老花老化进展，希望了解一下？",
    option: ["需要", "一般"],
    key: "yanHuanLaoHua",
  },
  {
    tit: "视知觉训练课程，您每天能坚持的时长？",
    option: ["20-30分钟", "40分钟左右"],
    key: "shiChang",
  },
];
let moban = {
  basicInfo: {
    age: null,
    leftVision: null,
    rightVision: null,
    problem: null,
  },
  ruoshiInfo: {
    leftVision: null,
    rightVision: null,
    type: null,
    isPiancha: null,
    yueDu: null,
    shiChang: null,
    liaoJie: null,
  },
  shuhouInfo: {
    leftVision: null,
    rightVision: null,
    xieShiAndRuoShi: null,
    liaoJie: null,
    fufa: null,
    shiChang: null,
  },
  shipilaoInfo: {
    yanJingMoHu: null,
    chongFuYueDu: null,
    yuanJinZhuanHuan: null,
    yanJingBuShi: null,
    shiPiLaoZhengZhuang: null,
    huanJieJiZhi: null,
    shiChang: null,
  },
  laohuaInfo: {
    fangDa: null,
    shiChang: null,
    naYuan: null,
    yanHuanLaoHua: null,
    yongYanMoHu: null,
  },
};
export default { ruoshiInfo, moban, shipilaoInfo, laohuaInfo };
